var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB4ED509-A999-4C8C-9CFE-BA1739A5B85B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Appointment-Details---Home-Cataloging",
    transform: "translate(-264.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Service-Specialist",
    transform: "translate(16.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Appointment-Status",
    transform: "translate(248.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pending-Icon",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BDBDBD",
    cx: 10.5,
    cy: 10.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46075439,8.53125 C9.34430917,8.53125 10.0362367,8.73011531 10.943272,9.16040725 L12.0119386,9.68853732 L12.1822981,9.7606008 L12.3303163,9.80930594 C12.4050968,9.83175331 12.4676683,9.84459815 12.5205126,9.84960741 C13.0177301,9.89674008 13.6100187,9.7444479 14.3089283,9.3541051 C14.9417886,9.000651 15.7413544,9.22715447 16.0948085,9.86001475 C16.4482626,10.492875 16.2217591,11.2924408 15.5888988,11.6458949 C14.4546691,12.2793651 13.3454502,12.564573 12.2727918,12.4628926 C12.0391604,12.440746 11.8086349,12.3934232 11.5756201,12.3234775 C11.4033862,12.2717769 11.2336204,12.2092415 11.0547359,12.1332733 L10.672316,11.9582972 L10.1105298,11.6756129 C9.36075457,11.2967921 8.94113623,11.15625 8.46075439,11.15625 C7.88057242,11.15625 7.5252762,11.3139056 7.26818552,11.6698005 L7.17613247,11.8126327 C6.81362229,12.4403495 6.01088477,12.6553419 5.38316804,12.2928317 C4.7554513,11.9303215 4.54045891,11.127584 4.90296909,10.4998673 C5.64977108,9.20671707 6.89582313,8.53125 8.46075439,8.53125 Z",
    id: "Path-3",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.481360034ccf261cefcf450829a4d8c3.svg";
export { ForwardRef as ReactComponent };